import React, { useEffect, useRef, useState } from 'react'
import $ from 'jquery'
import 'datatables.net'
import 'datatables.net-dt/css/dataTables.dataTables.css'
import Select from 'react-select'
import chroma from 'chroma-js'
import { FiMenu } from 'react-icons/fi'
import { Link, useNavigate } from "react-router-dom";
import { deleteIdData } from "../../../lib/collegelistinfo";



const states = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' }
];


const stateOptions = states.map((state) => ({
  value: state.code,
  label: state.name,
  color: chroma.random().hex()
}));

const AdminCollegeDatatable = ({ data, loading, setRefreshData , refreshData}) => {
  const tableRef = useRef(null)
  
  const columnMenuRef = useRef(null)
  const columnTitles = [
    'Unit ID',
    'COLLEGE',
    'STATE',
    'CITY',
    'TYPE',
    'POPULATION',
    'US NEWS RANK',
    'GRD.RATE',
    'RATE',
    'GPA AVG',
    'SAT English',
    'SAT Math',
    'SAT TOT.',
    'In-State Tuition $',
    'Out-State Tuition $',
    'URL',
    'NET PRICE CALC URL',
'UPDATE',
'DELETE',
    
  ]
  const [visibleColumns, setVisibleColumns] = useState(
    columnTitles.map((_, index) => index !== 0) // 0. index false, diğerleri true
  )
  const [openColumnMenu, setOpenColumnMenu] = useState(false)
  const [selectedStates, setSelectedStates] = useState([])
  const navigate = useNavigate()
  const handleDelete =  async(id) => {
    const choice = window.confirm(
      'Are You Sure?'
    );
    if (choice) {
      setRefreshData(true)
      await deleteIdData(id);
      setRefreshData(false)
      // GetData();
      console.log("Delete",id);
      //router.refresh();
    }
   
  };

  const initializeDataTable = () => {
    if (tableRef.current) {
      const filteredData = data.filter((row) => {
        const stateMatch =
          selectedStates.length === 0 || selectedStates.includes(row.state);
        return stateMatch;
      });
      {(refreshData) ? <div className="spinner-container">
        <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div> : ""}
  
      const formattedData = filteredData.map(row => {
        const { id, created_at, ...rest } = row;
  
        return [
          ...Object.values(rest).map((cell, index) =>{
            // 15 ve 16. indexlerde URL kontrolü
            if (index === 15 || index === 16) {
                const url = cell; // Hücredeki URL'yi al
                const shortenedUrl = url.length > 10 ? url.slice(0, 10) + '...' : url;
                return `<a href="https://${url}"  target="_blank" rel="noopener noreferrer">${shortenedUrl}</a>`;
            }
            return cell;
        }),
          // Update button
          `<button class="btn btn-success btn-sm update-btn" data-id="${id}">Update</button>`,
          // Delete button
          `<button class="btn btn-danger btn-sm delete-btn" data-id="${id}">Delete</button>`
        ];
      });
  
      const columnDefinitions = columnTitles.map((title, index) => {
        const formattedTitle = title.split(' ').map((word, idx) => {
            return idx === 1 ? `<span style="display: block;">${word}</span>` : word;
        }).join(' ');

        if (index >= 6 && index <= 12) {
            return {
                title: `<div class="column-header">${formattedTitle}</div>`,
                width: "60px",
            };
        }

        return {
            title: `<div class="column-header">${formattedTitle}</div>`,
            width: index === 1 ? "180px" : index === 2 ? "60px" : "100px",
        };
    });
  
      $(tableRef.current).DataTable({
        data: formattedData,
        columns: columnDefinitions,
        columnDefs: visibleColumns.map((visible, index) => ({
          targets: index,
          visible,
        })),
        destroy: true,
        searching: true,
        scrollX: true,
        initComplete: function () {
          const searchInput = $('input[type="search"]');
          searchInput.attr('placeholder', 'Search...');
        },
        drawCallback: function () {
          const table = $(tableRef.current).DataTable();
          table.rows().every(function () {
            const data = this.data();
            const unitId = data[0];
            
            $(this.node())
              .find('td')
              .each((index, cell) => {
                const cellData = $(cell).text();
                $(cell).attr('title', cellData);                     
              });
              $(this.node()).find('.update-btn').on('click', (e) => {
                const id = $(e.currentTarget).data('id');
                navigate(`/admin/admin-collegelistinfo-edit/${id}`); // Navigate to abc page
              });
              $(this.node()).find('.delete-btn').on('click', (e) => {
                const id = $(e.currentTarget).data('id');
                handleDelete(id)
                // navigate(`/admin/admin-collegelistinfo-edit/${id}`); // Navigate to abc page
              });
          });
        },
      });
    }
  };
  useEffect(() => {
      initializeDataTable();
  
      const handleResize = () => {
        if (tableRef.current) {
          $(tableRef.current).DataTable().destroy();
          initializeDataTable();
        }
      };
  
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
        if (tableRef.current) {
          $(tableRef.current).DataTable().destroy();
        }
      };
  }, [data, visibleColumns, selectedStates]);

  const handleColumnVisibilityChange = (index) => {
    const newVisibleColumns = [...visibleColumns]
    newVisibleColumns[index] = !newVisibleColumns[index]
    setVisibleColumns(newVisibleColumns)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        columnMenuRef.current &&
        !columnMenuRef.current.contains(event.target) &&
        !event.target.classList.contains('column_menu')
      ) {
        setOpenColumnMenu(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const colourStyles = {
    control: (styles) => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const color = chroma(data.color)
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? data.color
          : isFocused
          ? color.alpha(0.1).css()
          : undefined,
        color: isDisabled
          ? '#ccc'
          : isSelected
          ? chroma.contrast(color, 'white') > 2
            ? 'white'
            : 'black'
          : data.color,
        cursor: isDisabled ? 'not-allowed' : 'default',
        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled
            ? isSelected
              ? data.color
              : color.alpha(0.3).css()
            : undefined
        }
      }
    },
    multiValue: (styles, { data }) => {
      const color = chroma(data.color)
      return {
        ...styles,
        backgroundColor: color.alpha(0.1).css()
      }
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: data.color
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: data.color,
      ':hover': {
        backgroundColor: data.color,
        color: 'white'
      }
    })
  }

  const headerClasses = [
    'first_header',
    'first_header',
    'first_header',
    'first_header',
    'first_header',
    'first_header',
    'second_header',
    'second_header',
    'third_header',
    'third_header',
    'third_header',
    'third_header',
    'third_header',
    'fourth_header',
    'fourth_header',
    'fifth_header',
    'fifth_header',
    "sixth_header"
  ]

  return (
    <div className='dataTables_wrapper' >
      
      <div className='multi_select_parent'>
        
        <div className='column__div'>
          <FiMenu
            className='column_menu'
            onClick={() => setOpenColumnMenu(!openColumnMenu)}
          />
          {openColumnMenu && (
            <div className='column-toggle-checkboxes' ref={columnMenuRef}>
              {columnTitles.map((title, index) => (
                <label key={index}>
                  <input
                    type='checkbox'
                    checked={visibleColumns[index]}
                    onChange={() => handleColumnVisibilityChange(index)}
                  />
                  {title}
                </label>
              ))}
            </div>
          )}
        </div>
       
        <div className='filter__div'>
          <Select
            isMulti
            options={stateOptions}
            className='state-select'
            placeholder='Select states...'
            onChange={(selectedOptions) => {
              const selectedValues = selectedOptions.map(
                (option) => option.value
              )
              setSelectedStates(selectedValues)
            }}
            styles={colourStyles}
          />
        </div>

      </div>

     
      <table className='display' width='100%' ref={tableRef}>
        <thead>
          <tr id='no-sorting'>
            <th className='main-header first_header' colSpan='6'>
            PHYSICAL SETTINGS
            </th>
            <th className='main-header second_header' colSpan='2'>
            ACADEMICS
            </th>
            <th className='main-header third_header' colSpan='5'>
            ADMISSION
            </th>
            <th className='main-header fourth_header' colSpan='2'>
            FINANCE
            </th>
            <th className='main-header fifth_header' colSpan='4'>

            </th>
            {/* <th className='main-header fifth_header' colSpan='3'>

            </th> */}
           
            {/* <th className='main-header sixth_header' colSpan='2'>
              nn
            </th> */}
          </tr>
          <tr>
            {columnTitles.map((title, index) => (
              <th key={index} className={`sub-header ${headerClasses[index]}`}>
                {title}
              </th>
            ))}
          </tr>
        </thead>

        {/* <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>

              {Object.values(row).map((cell, cellIndex) => (
                <td key={cellIndex} className='data-cell'>
                {cell}

                </td>
               ))} 
            </tr>
          ))}
        </tbody> */}
      </table>
      {(loading) ? <div className="spinner-container">
    <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
    </div>
</div> : ""}
  
    </div>
  )
}

export default AdminCollegeDatatable
